import { createSelector } from 'reselect';
import {
    studentChapterFlashcardsPath,
    studentGrammarItemPath,
    studentGrammarPath,
    studentHomeworkPath,
    studentLessonFlashcardsPath,
    studentLingobotPath,
    studentPracticePath,
    studentPracticeSequencePath,
    studentQuizNextPath,
    studentQuizPath,
    studentVocabularyPath,
} from '@lingoda/router';
import { SubscriptionStatus, currentSubscriptionSelector } from '@lingoda/subscriptions';

export const selfLearningRoutes = [
    { path: studentChapterFlashcardsPath(undefined as never), matchPrefix: true },
    { path: studentLessonFlashcardsPath(undefined as never), matchPrefix: true },
    { path: studentGrammarItemPath(undefined as never), matchPrefix: true },
    { path: studentGrammarPath(undefined as never), matchPrefix: true },
    { path: studentHomeworkPath(undefined as never), matchPrefix: true },
    // `{}` not `undefined`: the default `status` param would otherwise land in the query string,
    // and a path carrying `?status=pending` can never prefix-match a pathname
    { path: studentPracticePath({} as never), matchPrefix: true },
    { path: studentPracticeSequencePath(undefined as never), matchPrefix: true },
    { path: studentQuizPath(undefined as never), matchPrefix: true },
    { path: studentVocabularyPath(undefined as never), matchPrefix: true },
    { path: studentQuizNextPath(undefined as never), matchPrefix: true },
    { path: studentLingobotPath(undefined as never), matchPrefix: true },
];

export const selfLearningAccessSelector = createSelector(
    currentSubscriptionSelector,
    (subscription) => Boolean(subscription && subscription.status !== SubscriptionStatus.Cancelled),
);
